import { HTTPInstance } from "@http/http-instance";
import { FeatureFlag } from "@http/constants";
import { getWaitersMock } from "./WaitersAPI.mock";
import type { Waiter } from "./WaitersAPI.model";

const getWaitersReal = async (restaurantId: string): Promise<Waiter[]> => {
  const { data } = await HTTPInstance.get<Waiter[]>(
    `/public/restaurants/${restaurantId}/waiters`,
  );
  return data;
};

export const getWaiters = (restaurantId: string): Promise<Waiter[]> =>
  FeatureFlag.USE_MOCK_WAITERS
    ? getWaitersMock()
    : getWaitersReal(restaurantId);
